import React, { useState } from "react";

const PopupContext = React.createContext();

export const PopupProvider = ({ children }) => {
    // ONBOARDING COMPLETED POPUPS
    const [showStorePOSConfirmConnect, setShowStorePOSConfirmConnect] = useState(false);
    const [showStoreAndPOSOnboardingCompleted, setShowStoreAndPOSOnboardingCompleted] = useState(false);
    const [showStoreWithoutPOSOnboardingCompleted, setShowStoreWithoutPOSOnboardingCompleted] = useState(false);
    const [showReorderSuggestionPopup, setShowReorderSuggestionPopup] = useState(false);
    const [showStripePopup, setShowStripePopup] = useState(false);
    // TODO: OTHER PAGES POPUPS ADD COMMENT HERE

    // GENERIC CONFIRMATION POPUP -> use this by calling Library.showConfirmationMessage({ ... })
    const [genericConfirmationPopup, setGenericConfirmationPopup] = useState({ show: false });

    return (
        <PopupContext.Provider
            value={{
                showStorePOSConfirmConnect,
                setShowStorePOSConfirmConnect,
                showStoreAndPOSOnboardingCompleted,
                setShowStoreAndPOSOnboardingCompleted,
                showStoreWithoutPOSOnboardingCompleted,
                setShowStoreWithoutPOSOnboardingCompleted,
                showReorderSuggestionPopup,
                setShowReorderSuggestionPopup,
                genericConfirmationPopup,
                setGenericConfirmationPopup,
                showStripePopup,
                setShowStripePopup
            }}>
            {children}
        </PopupContext.Provider>
    );
};

export const resetConfirmationPopup = setGenericConfirmationPopup => {
    setGenericConfirmationPopup({ show: false });
};

export default PopupContext;
